define(function (require) {
    var $ = require("jquery");

    $(".interactiontracker").click(function () {
        var el = $(this).attr("class");
        var res = el.split(" ");
        var interactions = [];
        res.forEach(function (item) {
            if (item != null && item.startsWith("interaction-")) {
                interactions.push(item);
            }
        });
        if (interactions != null && interactions.length > 0) {
            $.ajax({
                url: "/api/interactionstracker/recordgoal",
                data: JSON.stringify(interactions),
                contentType: "application/json; charset=utf-8",
                error: function () {},
                success: function (data) {},
                type: "POST"
            });
        }
    });

    return {
        RecordGoalFn: function RecordGoalFn(goals) {
            var interactions = goals.split(",");
            $.ajax({
                url: "/api/interactionstracker/recordgoal",
                data: JSON.stringify(interactions),
                contentType: "application/json; charset=utf-8",
                error: function () {},
                success: function (data) {},
                type: "POST"
            });
        }
    };
});
